export default __webpack_public_path__ + "static/media/38.c3a4c4f1.jpg";